
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/react-scheduler/recurring-events",
      function () {
        return require("private-next-pages/x/react-scheduler/recurring-events.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/react-scheduler/recurring-events"])
      });
    }
  